// import {
//   Box,
//   Button,
//   Grid,
//   Skeleton,
//   Tooltip,
//   tooltipClasses,
//   Typography,
// } from "@mui/material";
// import React, { useState } from "react";
// import { Check } from "@mui/icons-material";
// import { display, flexDirection, flexWrap, styled } from "@mui/system";

// const CustomTooltip = styled(({ className, ...props }) => (
//   <Tooltip {...props} classes={{ popper: className }} />
// ))(({ theme }) => ({
//   [`& .${tooltipClasses.tooltip}`]: {
//     backgroundColor: "#FFF",
//     color: "rgba(0, 0, 0, 0.5)",
//     fontSize: "12px",
//     border: "1px solid rgba(0, 0, 0, 0.2)",
//     padding: "8px 16px",
//     borderRadius: 0,
//   },
// }));

// export default function CarModel({ bgCar, CircleData, model }) {
//   const [activeTab, setActiveTab] = useState("Exterior");
//   const [selectedColor, setSelectedColor] = useState(CircleData?.[0] || {});
//   const [isLoaded, setIsLoaded] = useState(false);
//   return (
//     <div style={{ position: "relative", }}>
//       {/* Header Section */}
//       <Grid
//         style={{
//           display: "flex",
//           gap:"90%",
//           paddingTop: "6%",
//           paddingLeft:"13%",
//           paddingRight: "13%",
//         }}
//       >
//         <Grid item xs={6}>
//           <Typography
//             variant="inherit"
//             color="gray"
//             // backgroundColor="red"
//             letterSpacing={4}
//             fontFamily="KIAbodyLatinbasic_Regular"
//             sx={{
//               fontSize: "clamp(14px, 2vw, 16px)",
//             }}
//           >
//             DESIGN
//           </Typography>
//           <Typography
//             variant="h4"
//             fontFamily="KIAbodyLatinbasic_Bold"
//             lineHeight={3}
//             sx={{
//               fontSize: "clamp(24px, 7vw, 46px)",
//             }}
//           >
//             {model}
//           </Typography>
//         </Grid>

//         {/* Tab Buttons */}
//         {model !== "Ev6" && (
//           <Grid item xs={6}>
//             <div style={{ float: "right", display: "flex" }}>
//               <Button
//                 variant="text"
//                 onClick={() => setActiveTab("Exterior")}
//                 sx={{
//                   borderTop:
//                     activeTab === "Exterior" ? "3px solid #BB162B" : "none",
//                   fontWeight: activeTab === "Exterior" ? "bold" : "normal",
//                   textTransform: "capitalize",
//                   borderRadius: 0,
//                   fontSize: "clamp(14px, 2vw, 18px)",
//                   color: "#000",
                  
//                 }}
//               >
//                 Exterior
//               </Button>
//               <Button
//                 variant="text"
//                 onClick={() => setActiveTab("Interior")}
//                 sx={{
//                   borderTop:
//                     activeTab === "Interior" ? "3px solid #BB162B" : "none",
//                   fontWeight: activeTab === "Interior" ? "bold" : "normal",
//                   textTransform: "capitalize",
//                   borderRadius: 0,
//                   fontSize: "clamp(14px, 2vw, 18px)",
//                   color: "#000",
//                 }}
//               >
//                 Interior
//               </Button>
//             </div>
//           </Grid>
//         )}
//       </Grid>

//       {/* Content Section */}
//       <Grid container display={"flex"} pt={"2%"} pb={"7%"} px={"13%"} gap={1}justifyContent={"center"}>
//         {/* Exterior Section */}
//         {activeTab === "Exterior" && (
//           <>
//             <Grid style={{height:"70vh",}}>
//               {!isLoaded && (
//                 <Skeleton
//                   animation="wave"
//                   variant="rectangular"
//                   width="100%"
//                   height="100%"
                  
//                 />
//               )}
//               <Box
//                 component="img"
//                 loading="eager"
//                 decoding="async"
//                 src={selectedColor.imgSrc}
//                 onLoad={() => setIsLoaded(true)}
//                 alt="Car Image"
//                 sx={{
//                   width: "100%",
//                   height: "100%",
                  
//                 }}
//               />
//             </Grid>
//             <Grid >
//               <Typography variant="subtitle2" fontWeight={400}>
//                 Color : {selectedColor.title}
//               </Typography> 
//             </Grid> 

//             {CircleData?.length > 0 &&
//               CircleData.map((item) => (
//                 <Grid
//                   item
//                   key={item.title}
//                   onClick={() => setSelectedColor(item)} // Store full object
//                   style={{ cursor: "pointer",}}
//                 >
//                   <CustomTooltip title={item.title}>
//                     <Box
//                       sx={{
//                         width: { xs: 25, sm: 30, md: 35, lg: 40 }, // Responsive width
//                         height: { xs: 25, sm: 30, md: 35, lg: 40 }, // Responsive height
//                         borderRadius: "50%",
//                         border: "1px solid lightgray",
//                         background: item.color
//                           ? item.color
//                           : `linear-gradient(135deg, ${item.color1} 50%, ${item.color2} 50%)`,
//                         display: "flex",
//                         alignItems: "center",
//                         justifyContent: "center",
//                         position: "relative",
//                       }}
//                     >
//                       {/* Show tick only if selected */}
//                       {selectedColor.title === item.title && (
//                         <Check
//                           sx={{
//                             color: item.color === "#FFF" ? "#000" : "#FFF",
//                             fontSize: "17px",
//                           }}
//                         />
//                       )}
//                     </Box>
//                   </CustomTooltip>
//                 </Grid>
//               ))}
//           </>
//         )}

//         {/* Interior Section (with fixed video positioning) */}
//         {activeTab === "Interior" && (
//           <Grid
//             item
//             xs={12}
//             sx={{
//               position: "relative",
//               width: "100%",
//               height: "50vh", // Set a fixed height
//               display: "flex",
//               justifyContent: "center",
//               alignItems: "center",
//             }}
//           >
//             <video
//               autoPlay
//               loop
//               muted
//               playsInline
//               style={{
//                 width: "100%",
//                 height: "100%",
//                 objectFit: "contain",
//               }}
//             >
//               <source src={bgCar} type="video/mp4" />
//               Your browser does not support the video tag.
//             </video>
//           </Grid>
//         )}
//       </Grid>
//     </div>
//   );
// }
































import {
  Box,
  Button,
  Skeleton,
  Tooltip,
  tooltipClasses,
  Typography,
  styled,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Check } from "@mui/icons-material";

const CustomTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#FFF",
    color: "rgba(0, 0, 0, 0.5)",
    fontSize: "12px",
    border: "1px solid rgba(0, 0, 0, 0.2)",
    padding: "8px 16px",
    borderRadius: 0,
  },
}));

export default function CarModel({ bgCar, CircleData, model, trimOptions }) {
  const [activeTab, setActiveTab] = useState("Exterior");
  const [isLoaded, setIsLoaded] = useState(false);
  const [activeTrim, setActiveTrim] = useState(trimOptions?.[0] || null);

  const colorList = Array.isArray(CircleData)
    ? CircleData
    : CircleData?.[activeTrim] || [];

  const [selectedColor, setSelectedColor] = useState(colorList[0] || {});

  useEffect(() => {
    setSelectedColor(colorList[0] || {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTrim]);

  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <div style={{ position: "relative", }}>
      {/* Header Section */}
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          rowGap: "16px",
          justifyContent: "space-between",
          alignItems: "flex-start",
          paddingTop: "6%",
          paddingLeft: isSmallScreen ? "6%" : "13%",
          paddingRight: isSmallScreen ? "6%" : "13%",
        }}
      >
        <div style={{ flex: "1 1 auto", minWidth: 0 }}>
          <Typography
            variant="inherit"
            color="gray"
            letterSpacing={4}
            fontFamily="KIAbodyLatinbasic_Regular"
            style={{
              fontSize: "clamp(14px, 2vw, 16px)",
            }}
          >
            DESIGN
          </Typography>
          <Typography
            variant="h4"
            fontFamily="KIAbodyLatinbasic_Bold"
            lineHeight={3}
            style={{
              fontSize: "clamp(20px, 7vw, 40px)",
            }}
          >
            {model}
          </Typography>
          {trimOptions?.length > 0 && (
            <div
              style={{
                display: "flex",
                borderRadius: "22px",
                overflow: "hidden",
                width: "fit-content",
              }}
            >
              {trimOptions.map((trim) => (
                <Button
                  key={trim}
                  onClick={() => setActiveTrim(trim)}
                  style={{
                    borderRadius: 0,
                    textTransform: "none",
                    padding: "6px 22px",
                    fontFamily: "KIAbodyLatinbasic_Bold",
                    backgroundColor: activeTrim === trim ? "#000" : "#eee",
                    color: activeTrim === trim ? "#fff" : "#000",
                  }}
                >
                  {trim}
                </Button>
              ))}
            </div>
          )}
        </div>

        {/* Tab Buttons */}
        {model !== "Ev6" && (
          <div style={{ display: "flex", gap: "8px" }}>
            <Button
              variant="text"
              onClick={() => setActiveTab("Exterior")}
              style={{
                borderTop: activeTab === "Exterior" ? "3px solid #BB162B" : "none",
                fontWeight: activeTab === "Exterior" ? "bold" : "normal",
                textTransform: "capitalize",
                borderRadius: 0,
                fontSize: "clamp(14px, 2vw, 18px)",
                color: "#000",
                // backgroundColor:"yellow",
                height:"7vh"
              }}
            >
              Exterior
            </Button>
            <Button
              variant="text"
              onClick={() => setActiveTab("Interior")}
              style={{
                borderTop: activeTab === "Interior" ? "3px solid #BB162B" : "none",
                fontWeight: activeTab === "Interior" ? "bold" : "normal",
                textTransform: "capitalize",
                borderRadius: 0,
                fontSize: "clamp(14px, 2vw, 18px)",
                color: "#000",
                height:"7vh"

              }}
            >
              Interior
            </Button>
          </div>
        )}
      </div>

      {/* Content Section */}
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          gap: "8px",
          paddingTop: "2%",
          paddingBottom: "7%",
          paddingLeft: "13%",
          paddingRight: "13%",
        }}
      >
        {/* Exterior Section */}
        {activeTab === "Exterior" && (
          <>
            <Box sx={{ flex: "1 1 70%", height: { xs: '30vh', sm: '40vh', md: '70vh' }, minWidth: isSmallScreen ? "90%" : "50%", position: "relative" }}>
              {!isLoaded && <Skeleton animation="wave" variant="rectangular" width="100%" height="100%" />}
              <Box
                component="img"
                loading="eager"
                decoding="async"
                src={selectedColor.imgSrc}
                onLoad={() => setIsLoaded(true)}
                alt="Car Image"
                sx={{
                  width: "100%",
                  height: "100%",
                  objectFit: { xs: "contain", sm: "cover" },
                  objectPosition: "center",
                }}
              />
            </Box>

            <div style={{ width: "100%", textAlign: "center", marginTop: "8px" }}>
              <Typography variant="subtitle2" fontWeight={400}>
                Color : {selectedColor.title}
              </Typography>
            </div>

            {colorList?.length > 0 &&
              colorList.map((item) => (
                <div
                  key={item.title}
                  onClick={() => setSelectedColor(item)}
                  style={{ cursor: "pointer" }}
                >
                  <CustomTooltip title={item.title}>
                    <Box
                      sx={{
                        width: { xs: 25, sm: 30, md: 35, lg: 40 },
                        height: { xs: 25, sm: 30, md: 35, lg: 40 },
                        borderRadius: "50%",
                        border: "1px solid lightgray",
                        background: item.color
                          ? item.color
                          : `linear-gradient(135deg, ${item.color1} 50%, ${item.color2} 50%)`,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        position: "relative",
                      }}
                    >
                      {selectedColor.title === item.title && (
                        <Check
                          sx={{
                            color: item.color === "#FFF" ? "#000" : "#FFF",
                            fontSize: "17px",
                          }}
                        />
                      )}
                    </Box>
                  </CustomTooltip>
                </div>
              ))}
          </>
        )}

        {/* Interior Section */}
        {activeTab === "Interior" && (
          <div
            style={{
              position: "relative",
              width: "100%",
              height: "50vh",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <video
              autoPlay
              loop
              muted
              playsInline
              preload="auto"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "contain",
              }}
            >
              <source src={bgCar} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
        )}
      </div>
    </div>
  );
}
